import PropTypes from 'prop-types';

/** This is simply to provide clear definition of what a column should consist of **/
const BrColumns = (props) => {
  return props;
};
BrColumns.PropTypes = {
  key: PropTypes.string.isRequired, // this should match the keys used in data row object
  displayName: PropTypes.string, // will be rendered as Header Text, name will be used if this is not provided
  titleAlign: PropTypes.oneOf(['left', 'center', 'right']),
  contentAlign: PropTypes.oneOf(['left', 'center', 'right']),

  column: PropTypes.func,
  columnConfig: PropTypes.object,

  width: PropTypes.number, // if not specified, will take on column's default, or 200 if column doens't have default
  flexGrow: PropTypes.number, // default=0
  flexShrink: PropTypes.number, // default=0
  // this is required if any of filter/sort capability is used
  type: PropTypes.oneOf(['string', 'number', 'checkboxEnum']),
  isSearchable: PropTypes.bool,

  isSortable: PropTypes.bool,
  isAdvanceSort: PropTypes.bool,
  isFilterable: PropTypes.bool,
  filterValues: PropTypes.array,

  exportEnabled: PropTypes.bool,
};
export default BrColumns;
